import { render } from "./SectionTitle.vue?vue&type=template&id=c7becb04&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=c7becb04&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7becb04"]])

export default __exports__